module.exports = {
  attach: function() {
    const $plp = $('.search-results');
      if ($plp.is('*')) {
        var products = $('#gtm-pdp-products').attr('data-gtm-products');
        $('body').trigger('gtm:eec:productImpressions', products);
      }
  }
}